import qrSvg from "./chat-install-qr.svg?raw";

/** URL PWA Chat (QR d’install mobile). */
export const CHAT_INSTALL_URL = "https://chat.app.aureliasuite.fr/";

/** Data-URL SVG du QR (généré localement, pas d’API tierce). */
export function chatInstallQrDataUrl(): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(qrSvg)}`;
}
